const tableTitleAreas = {
  title: 'Departments',
  placeholder: 'Search by department'
}

export default tableTitleAreas;
